import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import arData from "./ar.json";
import enData from "./en.json";

const DICTS = { ar: arData, en: enData };

// Simple deep-get with dot notation
function get(obj, path) {
  if (!path) return undefined;
  return path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export const LangContext = createContext({ lang: "ar", t: (k) => k, dict: arData });

export function detectLangFromPath(pathname) {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  return "ar";
}

export function LangProvider({ children }) {
  const location = useLocation();
  const lang = detectLangFromPath(location.pathname);
  const value = useMemo(() => {
    const dict = DICTS[lang] || DICTS.ar;
    const t = (key, fallback) => {
      const v = get(dict, key);
      if (v === undefined || v === null) return fallback !== undefined ? fallback : key;
      return v;
    };
    return { lang, t, dict };
  }, [lang]);

  // Update html lang attribute
  React.useEffect(() => {
    document.documentElement.setAttribute("lang", lang === "en" ? "en" : "es-AR");
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useT() {
  return useContext(LangContext);
}

export function localizedPath(lang, sub = "") {
  const base = lang === "en" ? "/en" : "/ar";
  if (!sub) return base;
  const clean = sub.startsWith("/") ? sub : `/${sub}`;
  return `${base}${clean}`;
}
